import { action } from '@ember/object';
import Router from '@ember/routing/router';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { ContactCustomProperty } from 'donor-elf-web/models/contact';
import ContactsCache, {
  type ContactCustomPropertyVisibility,
} from 'donor-elf-web/services/contacts-cache';

interface ComponentArgs {
  property: ContactCustomProperty;
  onEditVisibility: (visibility: ContactCustomPropertyVisibility) => void;
  onEditOptions: () => void;
  onRenameProperty: () => void;
  onReorderProperties: () => void;
  onDeleteProperty: () => void;
  onClose: () => void;
}

export default class ContactDetailsPropertiesCustomPropertyMoreDropdownIndexComponent extends Component<ComponentArgs> {
  @service declare contactsCache: ContactsCache;
  @service declare router: Router;

  @tracked stage: 'showOptions' | 'editVisibility' | 'rename' = 'showOptions';
  @tracked newVisibility?: ContactCustomPropertyVisibility;

  get currentPropertyVisibility() {
    let propertyUserSetting =
      this.contactsCache.customPropertyUserSettingForDetailPage[
        this.args.property.l
      ];
    if (propertyUserSetting?.show === true) {
      return 'show';
    } else if (propertyUserSetting?.hide === true) {
      return 'hide';
    } else {
      return 'hide-if-blank';
    }
  }

  get propertyIsHidden() {
    return (
      this.contactsCache.customPropertyUserSettingForDetailPage[
        this.args.property.l
      ]?.hide === true
    );
  }

  get propertyIsList() {
    return (
      this.contactsCache.customPropertiesByLowecaseLabel[
        this.args.property.l.toLowerCase()
      ].t === 'l'
    );
  }

  get propertyIsNotReadonly() {
    return !this.contactsCache.customPropertyLabelIsReadonly(
      this.args.property.l!,
    );
  }

  @action
  handleGroupByProperty() {
    this.router.transitionTo(
      'funds.fund.contacts.group-by.property',
      this.args.property.l,
    );
  }

  @action
  handleOnRename() {
    this.stage = 'rename';
  }

  @action
  handleEditVisibilityClicked() {
    this.newVisibility = this.currentPropertyVisibility;
    this.stage = 'editVisibility';
  }

  @action
  handleChangeVisibility(visibility: ContactCustomPropertyVisibility) {
    this.newVisibility = visibility;
  }
}
